<script lang="ts">
  let navClass = "";

  export { navClass as class };
</script>

<nav class="flex border-b border-white/10 {navClass}">
  <slot />
</nav>
